import { render, staticRenderFns } from "./signInMod.vue?vue&type=template&id=2bb8a781&scoped=true&lang=html&"
import script from "./signInMod.vue?vue&type=script&lang=js&"
export * from "./signInMod.vue?vue&type=script&lang=js&"
import style0 from "./signInMod.vue?vue&type=style&index=0&id=2bb8a781&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb8a781",
  null
  
)

export default component.exports